import { useState } from 'react'

import { AppTemplate } from 'features/templates/types'

import useDebounce from 'v2/ui/utils/useDebounce'

const DEBOUNCE_TIME = 500 // ms

type AppTemplateDetailDescriptionStateProps = {
    template: AppTemplate
    onChange?: (template: Partial<AppTemplate>) => void
}

export function useAppTemplateDetailDescriptionState({
    template,
    onChange = () => {},
}: AppTemplateDetailDescriptionStateProps) {
    const debouncedOnChange = useDebounce(onChange, DEBOUNCE_TIME)

    const [localDescription, setLocalDescription] = useState(template.description)

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const value = e.target.value

        setLocalDescription(value)
        debouncedOnChange?.({ description: value })
    }

    return {
        description: localDescription,
        handleChange,
    }
}
